import { TemplateGalleryCard } from '@common/types';
import { TemplateGalleryCard as LibraryTemplateGalleryCard } from '@wix/wix-studio-marketplace-lib';
import {
  Industry,
  Style,
  SiteType,
} from '@wix/ambassador-partners-marketplace-v1-template-listing/types';
import { templatePath } from '@components/Hooks/useRouter';

export const INITIAL_TEMPLATES_LOAD_SIZE = 16;
export const TEMPLATES_DISPLAY_PAGE_SIZE = 8;
export const PROFILE_INITIAL_TEMPLATE_COUNT = 8;

// TODO: Remove this when specs.marketplace.enableProfilePageUplift is merged
export const INITIAL_TEMPLATES_LOAD_SIZE_OLD = 18;
export const TEMPLATES_DISPLAY_PAGE_SIZE_OLD = 6;
export const PROFILE_INITIAL_TEMPLATE_COUNT_OLD = 6;

export const mapTemplatesToLibraryFormat = (
  templates: TemplateGalleryCard[],
): LibraryTemplateGalleryCard[] => {
  return templates.map((template) => ({
    ...template,
    industries: template.industries?.map(
      (ind) => Industry[ind as keyof typeof Industry],
    ),
    styles: template.styles?.map((style) => Style[style as keyof typeof Style]),
    siteTypes: template.siteTypes?.map(
      (style) => SiteType[style as keyof typeof SiteType],
    ),
  }));
};

export const buildTemplatePageLink = (templateId?: string | null): string => {
  if (!templateId) return '';
  return `${templatePath}/${templateId}`;
};

export const scrollToTemplatesSection = (
  elementRef: React.RefObject<HTMLElement>,
  isMobileView: boolean,
): void => {
  if (elementRef.current) {
    const offset = isMobileView ? 130 : 120;
    const targetPosition =
      elementRef.current.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      top: targetPosition - offset,
      behavior: 'smooth',
    });
  }
};

export const formatAverageRating = (
  rating: number,
  language: string,
): string => {
  return Intl.NumberFormat(language, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  }).format(rating);
};

export const calculateNextCount = (
  currentVisibleCount: number,
  totalAvailable: number,
): number => {
  return Math.min(
    currentVisibleCount + TEMPLATES_DISPLAY_PAGE_SIZE,
    totalAvailable,
  );
};

export const getNewTemplateSliceIndices = (galleryIndex: number) => {
  const startIndex =
    PROFILE_INITIAL_TEMPLATE_COUNT + galleryIndex * TEMPLATES_DISPLAY_PAGE_SIZE;
  const endIndex = startIndex + TEMPLATES_DISPLAY_PAGE_SIZE;
  return { startIndex, endIndex };
};

// TODO: Remove this when specs.marketplace.enableProfilePageUplift is merged
export const calculateNextCountOLD = (
  currentVisibleCount: number,
  totalAvailable: number,
): number => {
  return Math.min(
    currentVisibleCount + TEMPLATES_DISPLAY_PAGE_SIZE_OLD,
    totalAvailable,
  );
};

// TODO: Remove this when specs.marketplace.enableProfilePageUplift is merged
export const getNewTemplateSliceIndicesOLD = (galleryIndex: number) => {
  const startIndex =
    PROFILE_INITIAL_TEMPLATE_COUNT_OLD +
    galleryIndex * TEMPLATES_DISPLAY_PAGE_SIZE_OLD;
  const endIndex = startIndex + TEMPLATES_DISPLAY_PAGE_SIZE_OLD;
  return { startIndex, endIndex };
};
